/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsurancePayor } from './InsurancePayor';
import {
    InsurancePayorFromJSON,
    InsurancePayorFromJSONTyped,
    InsurancePayorToJSON,
    InsurancePayorToJSONTyped,
} from './InsurancePayor';

/**
 * 
 * @export
 * @interface GetExaCarePayerList200Response
 */
export interface GetExaCarePayerList200Response {
    /**
     * 
     */
    data?: Array<InsurancePayor>;
}

/**
 * Check if a given object implements the GetExaCarePayerList200Response interface.
 */
export function instanceOfGetExaCarePayerList200Response(value: object): value is GetExaCarePayerList200Response {
    return true;
}

export function GetExaCarePayerList200ResponseFromJSON(json: any): GetExaCarePayerList200Response {
    return GetExaCarePayerList200ResponseFromJSONTyped(json, false);
}

export function GetExaCarePayerList200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetExaCarePayerList200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(InsurancePayorFromJSON)),
    };
}

export function GetExaCarePayerList200ResponseToJSON(json: any): GetExaCarePayerList200Response {
    return GetExaCarePayerList200ResponseToJSONTyped(json, false);
}

export function GetExaCarePayerList200ResponseToJSONTyped(value?: GetExaCarePayerList200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(InsurancePayorToJSON)),
    };
}

